import GlobalStyles from '@mui/material/GlobalStyles';
import React from 'react';

type ButtonDataVariantDebugGlobalStylesProps = {
  enabled: boolean;
};

/**
 * When `enabled`, outlines controls with `data-variant` and shows the value in a corner badge.
 * Toggled via Command-K (`DebugFlags.ButtonVariant`).
 */
export default function ButtonDataVariantDebugGlobalStyles({
  enabled,
}: ButtonDataVariantDebugGlobalStylesProps) {
  if (!enabled) {
    return null;
  }

  return (
    <GlobalStyles
      styles={{
        '[data-variant]': {
          position: 'relative',
          outline: '1px dashed rgba(236, 72, 153, 0.85)',
          outlineOffset: 0,
        },
        '[data-variant]::after': {
          content: 'attr(data-variant)',
          position: 'absolute',
          top: 0,
          right: 0,
          zIndex: 99999,
          fontSize: '10px',
          fontFamily:
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
          lineHeight: 1.2,
          padding: '2px 5px',
          borderRadius: '3px',
          backgroundColor: 'rgba(168, 85, 247, 0.95)',
          color: '#fff',
          pointerEvents: 'none',
          whiteSpace: 'nowrap',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.35)',
          maxWidth: 'min(180px, 40vw)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }}
    />
  );
}
